import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StepOption, LocalityOption, StopOption, TestOption } from '../../../shared/components/place_select/PlaceOption';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';

export default class PlaceOptionContainer extends Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        isDisabled: PropTypes.bool,
        isFocused: PropTypes.bool,
        isSelected: PropTypes.bool,
        onFocus: PropTypes.func,
        onSelect: PropTypes.func,
        item: PropTypes.object.isRequired
    };

    handleMouseDown(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.onSelect(this.props.option, event);
    }

    handleMouseMove (event) {
        if (this.props.isFocused) return;
        //this.props.onFocus(this.props.option, event);
    }

    handleMouseEnter(event) {
        //this.props.onFocus(this.props.option, event);
    }

    render () {
        const { item, ...others } = this.props;

        switch (item.type) {
            case 'step':
                return (
                    <StepOption
                        {...others}
                        option={item}
                        onMouseDown={::this.handleMouseDown}
                        onMouseEnter={::this.handleMouseEnter}
                        onMouseMove={::this.handleMouseMove}
                    />
                );
            case 'locality':
                return (
                    <LocalityOption
                        {...others}
                        option={item}
                        onMouseDown={::this.handleMouseDown}
                        onMouseEnter={::this.handleMouseEnter}
                        onMouseMove={::this.handleMouseMove}
                    />
                );
            case 'stop':
                const isBus = !isEmpty(item.stop.purpose) && includes(item.stop.purpose, 'bus');
                const isLodging = !isEmpty(item.stop.purpose) && includes(item.stop.purpose, 'lodging');

                return (
                    <StopOption
                        {...others}
                        isBus={isBus}
                        isLodging={isLodging}
                        option={item}
                        onMouseDown={::this.handleMouseDown}
                        onMouseEnter={::this.handleMouseEnter}
                        onMouseMove={::this.handleMouseMove}
                    />
                );
        }
    }
}
